import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {CmsConfig, I18nModule, provideConfig, UrlModule} from '@spartacus/core';
import {GenericLinkModule, MediaModule} from '@spartacus/storefront';

import {AimoSimpleBannerModule} from '../simple-banner/aimo-simple-banner.module';
import {AimoSpinnerModule} from '../spinner/aimo-spinner.module';

import {AimoCmsCarouselModule} from "../carousel/cms/aimo-cms-carousel.component.module";
import {AimoSimpleBannerContainerComponent} from "./aimo-simple-banner-container.component";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        I18nModule,
        MediaModule,
        GenericLinkModule,
        AimoSimpleBannerModule,
        AimoSpinnerModule,
        AimoCmsCarouselModule,
    ],
    providers: [
        provideConfig(<CmsConfig>{
            cmsComponents: {
                AimoSimpleBannerContainerComponent: {
                    component: AimoSimpleBannerContainerComponent,
                },
            },
        }),
    ],
    declarations: [AimoSimpleBannerContainerComponent],
    exports: [AimoSimpleBannerContainerComponent],
})
export class AimoSimpleBannerContainerModule {
}
